<div class="header-container">
  <div class="logo-container">
    <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
      <nb-icon icon="menu-2-outline"></nb-icon>
    </a>
    <a class="logo" href="#" (click)="navigateHome()"
      >GASTRO-<span>CMS</span></a
    >
  </div>
  <nb-select
    [selected]="currentTheme"
    (selectedChange)="changeTheme($event)"
    status="primary"
  >
    <nb-option *ngFor="let theme of themes" [value]="theme.value">
      {{ theme.name }}</nb-option
    >
  </nb-select>
</div>

<div class="header-container">
  <nb-actions size="small">
    <nb-action class="user-action">
      <nb-user
        [nbContextMenu]="userMenu"
        nbContextMenuTag="user-context-menu"
        nbContextMenuTrigger="hover"
        [onlyPicture]="userPictureOnly"
        [name]="user?.name"
        [picture]="user?.photo ? user.photo : null"
      >
      </nb-user>
    </nb-action>
  </nb-actions>
</div>
